module.exports = __webpack_public_path__ + "static/img/1_2.2586a0db.jpg";